import React from "react";

type HotkeySection = {
  title: string;
  items: { keys: string; desc: string }[];
};

type HotkeysOverlayProps = {
  sections: HotkeySection[];
  onClose: () => void;
};

export function HotkeysOverlay({ sections, onClose }: HotkeysOverlayProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative w-full max-w-4xl rounded-xl border border-[var(--color-border)] bg-[var(--color-panel)] shadow-2xl p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="text-sm uppercase tracking-wide text-[var(--color-muted)]">Shortcuts</div>
            <div className="text-lg font-black title-font">Tastaturkürzel</div>
          </div>
          <button className="text-sm text-[var(--color-muted)] hover:text-[var(--color-text)]" onClick={onClose}>
            Schließen
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {sections.map((section) => (
            <div
              key={section.title}
              className="space-y-1 rounded-md border border-[var(--color-border)] bg-[var(--color-panel-2)]/70 p-4"
            >
              <div className="font-semibold">{section.title}</div>
              <ul className="space-y-1 text-[13px] text-[var(--color-muted)]">
                {section.items.map((item) => (
                  <li key={item.keys}>
                    <span className="font-semibold text-[var(--color-text)]">{item.keys}</span> – {item.desc}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
